<script setup lang="ts">
import { NavigationsObject } from 'embeddables/src/Route'
import { Loader2 } from 'lucide-vue-next'
import { Toaster } from 'pejer/src/components/ui/toast'
import { computed, nextTick, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { usePejer } from './Pejer'
import Navbar from './components/Navbar/Navbar.vue'
// This is a workaround to force the component to re-render when the headers change
const renderComponent = ref(true)
const forceRender = async () => {
  renderComponent.value = false
  await nextTick()
  renderComponent.value = true
}

const pejer = usePejer()
watch(pejer.headers, () => {
  forceRender()
})
const route = useRoute()
watch(
  route,
  () => {
    forceRender()
  },
  { deep: true }
)
const routeSettings = computed(() => pejer.routeHandler.getRouteSetting())

var navigate = (r: NavigationsObject) => {
  pejer.routeHandler.pushRoute(r)
}
</script>
<template>
  <main class="text-secondaryBlack h-full">
    <RouterView v-slot="{ Component }">
      <Navbar
        v-if="pejer.routeHandler.displayableRoutes.value.length > 0"
        :route-definitions="pejer.routeHandler.displayableRoutes.value"
        :current-route-name="routeSettings.value.routeName"
        @navigate="navigate"
      />
      <div
        v-if="!$route.query.notEmbed && pejer.globalLoading.isLoading.value"
        class="flex items-center justify-center h-full p-5"
      >
        <Loader2 class="animate-spin text-secondaryBlack" />
      </div>
      <component v-else-if="renderComponent" :is="Component" />
    </RouterView>
  </main>
  <Toaster />
</template>
